var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 44,
    viewBox: "0 0 58 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0C3.38817 6.50838 3.49208 12.5869 7.19442 24.9768C11.6773 37.8038 28.2267 38.6684 29.4519 38.6924C30.5636 40.436 33.1083 42.7848 38.9398 44L39.5874 40.9451C34.5559 39.898 32.7144 37.9695 32.0812 36.9104L32.0692 36.9248C32.2794 35.7625 35.7497 24.0114 28.8719 14.4649C17.3565 1.7844 0 0 0 0ZM58 2.01736C48.5798 3.48475 47.6253 -0.19213 30.2736 9.44555C33.1013 12.7286 35.1416 16.607 36.2405 20.7882C37.3395 24.9693 37.4683 29.3439 36.6173 33.5818C45.6146 30.013 49.1018 24.033 50.1652 18.0529C50.1652 18.0529 53.2343 6.72693 58 2.01736ZM30.2736 9.44555L30.2687 9.44075V9.45036L30.2736 9.44555ZM6.38725 5.71585C6.38725 5.71585 19.4904 9.14055 27.0328 33.4377C19.9158 31.3027 16.8756 24.3212 15.8437 21.0261H15.8582C13.9746 15.2448 10.7288 9.99523 6.38725 5.71585Z",
    fill: "#E8450A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFresh);
export default __webpack_public_path__ + "static/media/fresh.596a422846537a7e75ed3bda66c1bc89.svg";
export { ForwardRef as ReactComponent };